<template>
  <div class="search-base search-container">
    <search-label-body :label="label" :label-hidden="!label" :columns="options['gridTemplateColumns']">
      <div>
        <vs-select class="w-full xl:w-32" autocomplete v-model="employeeState" @change="change" :disabled="readonly">
          <vs-select-item v-for="(state, index) in optionList" :key="index" :text="state.text || state.value" :value="state.value" />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import {valueDisasters} from "@/util/DisasterDataUtil";

export default {
  name: "SearchEmployeeType",
  components: {
    SearchLabelBody,
  },
  props: {
    label: {
      default: "계약상태",
      type: String,
    },
    value: String,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          'eps': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.employeeState = value;
    },
  },
  computed: {
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultValue = this.options && this.options['default'] ? this.options['default'] : "";
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const employeeState = query[_query_keys[0]];
      if (employeeState) {
        try {
          return {
            employeeState: employeeState || defaultValue,
          };
        } catch (e) {}
      }

      return {
        employeeState: defaultValue,
      };
    },
    optionList() {
      return [
        {
          text: '계약 중',
          value: 'activated'
        }, {
          text: '계약 종료',
          value: 'retired'
        },
        {
          text: '전체',
          value: 'all'
        },
      ];
    },
  },
  data() {
    return {
      employeeState: "",
    };
  },
  created() {
    this.employeeState = this.initData.employeeState;
    this.$emit("input", this.employeeState);
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
  },
};
</script>
